import React, { useEffect, useRef, useState } from 'react'
import { Overlay, Popover } from 'react-bootstrap'
import { useAppSelector } from 'hooks/store'
import GoBackHeader from 'components/organisms/GoBackHeader'
import { useWindowSize, Size } from 'hooks/useWindowSize'
import { useHistory } from 'react-router-dom'
import { routeToQuestionnairePage } from 'share/utils/questionnaireUtils'
import './styles.scss'

const ItemsMenu = (): JSX.Element => {
  const activeCase = useAppSelector((state) => state.activeCase)
  const history = useHistory()
  const [show, setShow] = useState(false)
  const [docsMenuItemName, setDocsMenuItemName] = useState('Docs')
  const [showDocsMenuItem, setShowDocsMenuItem] = useState(true)
  const [currentPath, setCurrentPath] = useState(history.location.pathname)
  const ref = useRef(null)
  const refMore = useRef(null)
  const size: Size = useWindowSize()
  const [placement, setPlacement] = useState<'top' | 'bottom'>('top')
  const questionnaireShownInstructionsFlag = useAppSelector(
    (state) => state.activeCase.matter?.questionnaireShownInstructionsFlag
  )
  const questionnaireShownTermsAndConditionsFlag = useAppSelector(
    (state) => state.activeCase.matter?.questionnaireShownTermsAndConditionsFlag
  )

  useEffect(() => {
    if (activeCase?.matter?.isAiEnabled) {
      if (activeCase.matter.isChatBotEnabled) {
        setDocsMenuItemName('Review')
      } else {
        setShowDocsMenuItem(false)
      }
    }
  }, [activeCase])

  useEffect(() => {
    setCurrentPath(history.location.pathname)
  }, [history.location.pathname])

  useEffect(() => {
    if (size.width && size.width > 768 && size.width < 1201) {
      setPlacement('top')
    } else {
      setPlacement('bottom')
    }
  }, [size])

  function onClickQuestionnaire() {
    const questionnaireRoute = routeToQuestionnairePage(
      questionnaireShownInstructionsFlag || false,
      questionnaireShownTermsAndConditionsFlag || false
    )

    history.push(questionnaireRoute)
  }

  function onClickCourses() {
    if (activeCase.matter?.clientCode) {
      history.push('/dashboard/courses')
    }
  }

  return (
    <>
      <div id='case-level-navbar' className='ui-dashboard-menu'>
        <div
          className={`ui-dashboard-menu-item ${
            currentPath == '/dashboard/case' && !show ? 'active' : ''
          }`}
          onClick={() => history.push('/dashboard/case')}
        >
          <span className='mdi mdi-map-marker-outline' />
          <h5>Home</h5>
        </div>

        {showDocsMenuItem && (
          <div
            className={`ui-dashboard-menu-item ${
              currentPath == '/dashboard/documents' && !show ? 'active' : ''
            }`}
            onClick={() => history.push('/dashboard/documents')}
          >
            <span className='mdi mdi-file-multiple-outline' />
            <h5>{docsMenuItemName}</h5>
          </div>
        )}

        {activeCase.matter?.clientCode && (
          <div
            className={`ui-dashboard-menu-item ${
              currentPath == '/dashboard/courses' && !show ? 'active' : ''
            }`}
            onClick={() => onClickCourses()}
          >
            <span className='mdi mdi-certificate' />
            <h5>Courses</h5>
          </div>
        )}

        {activeCase.matter?.questionnaireDisplayInClientPortalFlag && (
          <div
            className={`ui-dashboard-menu-item ${
              (currentPath == '/dashboard/questionnaires' ||
                currentPath == '/dashboard/questionnaires/introduction' ||
                currentPath == '/dashboard/questionnaires/terms') &&
              !show
                ? 'active'
                : ''
            }`}
            onClick={() => onClickQuestionnaire()}
          >
            <span className='mdi mdi-clipboard-outline' />
            <h5>Intake</h5>
          </div>
        )}

        <div
          className={`ui-dashboard-menu-item ${
            (currentPath == '/dashboard/caseinformation' ||
              currentPath == '/dashboard/lawfirminformation') &&
            !show
              ? 'active'
              : ''
          }`}
          onClick={() => setShow(!show)}
          ref={refMore}
        >
          <span className='mdi mdi-dots-horizontal' />
          <h5>More</h5>
        </div>
      </div>
      {size.width && size.width > 768 && (
        <Overlay
          show={show}
          target={refMore}
          placement={placement}
          container={ref.current}
          containerPadding={20}
          rootClose={true}
          rootCloseEvent='mousedown'
          onHide={() => setShow(!show)}
        >
          <Popover id='more-options'>
            <Popover.Content style={{ padding: 0 }}>
              <ul className='ui-dashboard-menu-more-options'>
                <li
                  onClick={() => {
                    setShow(!show)
                    history.push('/dashboard/caseinformation')
                  }}
                >
                  Case Information
                </li>
                <li
                  onClick={() => {
                    setShow(!show)
                    history.push('/dashboard/lawfirminformation')
                  }}
                >
                  Law Firm Information
                </li>
              </ul>
            </Popover.Content>
          </Popover>
        </Overlay>
      )}
      {size.width && size.width <= 768 && (
        <div className={`ui-fullscreen-card ${show && 'visible'}`}>
          <GoBackHeader
            text='More'
            icon='close'
            onClick={() => setShow(!show)}
          />
          <ul className='ui-dashboard-menu-more-options'>
            <li
              onClick={() => {
                history.push('/dashboard/caseinformation')
                setShow(!show)
              }}
            >
              Case Information
            </li>
            <li
              onClick={() => {
                history.push('/dashboard/lawfirminformation')
                setShow(!show)
              }}
            >
              Law Firm Information
            </li>
          </ul>
        </div>
      )}
    </>
  )
}

export default ItemsMenu
